import type React from 'react';

interface SVGIconProps {
    color?: string;
    secondaryColor?: string;
    style?: React.CSSProperties;
}

const defaultStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
};

export const ICON_COLORS = {
    primary: '#0f3157',
    secondary: '#ffffff',
    gTK: '#61B7A3',
    gK: '#D5C078',
    g1: '#C3D25A',
    g2: '#EB793F',
    g3: '#2F8467',
    g4: '#A35CA7',
    g5: '#5EA4E8',
    g6: '#ED1C26',
    g6M: '#AA1F2E',
    g7: '#5662AD',
    g8: '#00A079',
};

export function MyLessons_UnselectedIcon({ color, style = defaultStyle }: SVGIconProps) {
    const iconColor =
        typeof color === 'string' && ICON_COLORS[color as keyof typeof ICON_COLORS]
            ? ICON_COLORS[color as keyof typeof ICON_COLORS]
            : color;
    return (
        <svg
            style={style}
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <g stroke={iconColor} fill={iconColor}>
                <circle
                    strokeWidth="7"
                    strokeMiterlimit="10"
                    fill="none"
                    cx="50"
                    cy="50"
                    r="42.5"
                />
                <g className="plus-unselected">
                    <path d="M50,79c-2.21,0-4-1.79-4-4V25c0-2.21,1.79-4,4-4s4,1.79,4,4v50c0,2.21-1.79,4-4,4Z" />
                    <path d="M75,54H25c-2.21,0-4-1.79-4-4s1.79-4,4-4h50c2.21,0,4,1.79,4,4s-1.79,4-4,4Z" />
                </g>
            </g>
        </svg>
    );
}

export function MyLessons_SelectedIcon({ color, style = defaultStyle }: SVGIconProps) {
    const iconColor =
        typeof color === 'string' && ICON_COLORS[color as keyof typeof ICON_COLORS]
            ? ICON_COLORS[color as keyof typeof ICON_COLORS]
            : color;
    return (
        <svg
            style={style}
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <path
                fill={iconColor}
                className="plus-selected"
                d="M50,4C24.59,4,4,24.59,4,50s20.59,46,46,46,46-20.59,46-46S75.41,4,50,4ZM76.47,54h-22.47v22.47c0,2.21-1.79,4-4,4s-4-1.79-4-4v-22.47h-22.47c-2.21,0-4-1.79-4-4s1.79-4,4-4h22.47v-22.47c0-2.21,1.79-4,4-4s4,1.79,4,4v22.47h22.47c2.21,0,4,1.79,4,4s-1.79,4-4,4Z"
            />
        </svg>
    );
}
